import HomeBanner from "../../components/sections/front/HomeBanner";
import JobSection from "../../components/sections/front/JobSection";

const Home = () => {
  return (
    <>
      <HomeBanner/>
      <JobSection/>
    </>
  );
};

export default Home;
